@import '../../../../../../constants/spacing.module.less';

.modal-body {
  padding: @space-16;
}

.description {
  margin-bottom: @space-12;
}
